function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { SvgIcon } from '@material-ui/core';
export default function BoardIcon(props) {
  let output = /*#__PURE__*/React.createElement(SvgIcon, _extends({
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M928 70.4h-384v-38.4c0-18.133-13.867-32-32-32s-32 13.867-32 32v38.4h-384c-18.133 0-32 13.867-32 32v536.533h896v-536.533c0-18.133-13.867-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M992 692.267h-960c-17.067 0-32 14.933-32 32 0 18.133 13.867 32 32 32h414.933l-188.8 199.467c-11.733 12.8-11.733 33.067 1.067 44.8s33.067 11.733 44.8-1.067l176-185.6v178.133c0 18.133 13.867 32 32 32s32-13.867 32-32v-178.133l176 185.6c11.733 12.8 32 13.867 44.8 1.067 12.8-11.733 13.867-32 1.067-44.8l-188.8-199.467h414.933c18.133 0 32-13.867 32-32s-13.867-32-32-32z"
  })));
  return output;
}
